import { render, staticRenderFns } from "./ExcelGeoWork.vue?vue&type=template&id=1fa41a6e&scoped=true&"
import script from "./ExcelGeoWork.vue?vue&type=script&lang=js&"
export * from "./ExcelGeoWork.vue?vue&type=script&lang=js&"
import style0 from "./ExcelGeoWork.vue?vue&type=style&index=0&id=1fa41a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa41a6e",
  null
  
)

component.options.__file = "ExcelGeoWork.vue"
export default component.exports